import { Injectable } from '@angular/core';


import { HealthService } from '../cms/health/health.service';

@Injectable({
  providedIn: 'root'
})
export class HealthResolver  {
  constructor(private healthService: HealthService) {}

  resolve() {
     return this.healthService.getHealthContent();
  }
}
